import { 
        fileMidQryFunction,
        fileImporterBondQryFunction,
        fileHtsQryFunction,
        fileAdCvdQryFunction, 
        fileAdCvdWithRequestId, 
        fileBolQryFunction,
        fileCrQryFunction,
        fileCriteriaQryFunction,
        fileEsQryFunction,
        setManualResponse,
        getQryByShipmentAndType,
        reconcileESFunction,
        reconcileCRFunction
    } from '../apiCalls';

import store from '../store';

const initialState = {
    // initialValues
}

export const QryInputReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'INIT_QRY_FUNCTION': {
            // Replace (do not merge) so stale requestid/saveTo/qryOutput are cleared
            return { ...action.payload }
        }
        case 'SET_LOADER_STATE': {
            let newState = Object.assign({}, state);
            newState.loading = true;
            return Object.assign({}, state, { ...newState })
        } 
        case 'UNSET_LOADER_STATE': {
            let newState = Object.assign({}, state);
            newState.loading = false;
            return Object.assign({}, state, { ...newState })
        }

        case 'SET_REQUEST_ID': {
            let newState = Object.assign({}, state);
            newState.requestid = action.requestid;
            newState.mockResponseRequired = action.mockResponseRequired;
            return Object.assign({}, state, { ...newState })
        }
        case 'SET_PAGE': {
            let newState = Object.assign({}, state);
            newState.page = action.page;
            return Object.assign({}, state, { ...newState })    
        }

        case 'SET_MOCK_RESPONSE': {
            window.mockResponseCalled && setManualResponse(action);
            window.mockResponseCalled = false;
            return state;
        }
        case 'FILE_QRY_FUNCTION': {
            if(action.qryType === 'ADCVD'){
                fileAdCvdQryFunction(action.brokerId, action);
                return state;
            }
            else if(action.qryType === 'BOL'){
                fileBolQryFunction(action.brokerId, action);
                return state;
            }
            else if(action.qryType === 'CR'){
                fileCrQryFunction(action.brokerId, action);
                return state;
            }
            else if(action.qryType === 'CRITERIAQUERYQQ'){
                fileCriteriaQryFunction(action.brokerId, action);
                return state;
            }
            else if(action.qryType === 'ES'){
                fileEsQryFunction(action.brokerId, action);
                return state;
            }
            else if(action.qryType === 'HTS'){
                fileHtsQryFunction(action.brokerId, action);
                return state;
            }
            else if(action.qryType === 'MID'){
                fileMidQryFunction(action.brokerId, action);
                return state;
            }
            else if(action.qryType === 'IB'){
                fileImporterBondQryFunction(action.brokerId, action);
                return state;
            }   
            
        }
        case "GET_QRY_FUNCTION": {
            
            console.log("GET_QRY_FUNCTION", action.shipId, action.docType, action.qryType,action)  
            getQryByShipmentAndType(action.shipId, action.docType, action.qryType,action.additionalDataParamtt, action.hts)  
            return state; 
        }
        case "RECONCILE_FUNCTION": {
            if(action.qryType === "ES"){
                reconcileESFunction(action.shipmentId, action.qryType, action.bolIdData)
            }
            else{
                reconcileCRFunction(action.shipmentId, action.qryType)
            }
            return state;
        }
        default:
        return state
    }
}